import Vue from 'vue';
import { MessageBox } from 'element-ui';
Vue.prototype.$prompt = MessageBox.prompt;
export default Vue.extend({
    props: {
        tableData: { type: (Array), required: true },
    },
    methods: {
        async configurePrefix(action, item) {
            // Default to undefined instead of empty string because the input
            // validation doesn't mark the initial empty value as invalid.
            let inputValue = undefined;
            if (item) {
                inputValue = item.ipv4_prefix;
            }
            try {
                let value = undefined;
                if (action !== 'Delete') {
                    let result = await this.$prompt('Enter prefix below:', `${action} IPv4 Prefix`, {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        inputPattern: /^(\d{1,3}\.?){1,4}$/,
                        inputErrorMessage: 'Invalid IPv4 Prefix',
                        inputValue: inputValue,
                    });
                    value = result.value;
                }
                if (action === 'Add') {
                    this.$emit('prefix-action', action, value);
                }
                else if (action === 'Delete') {
                    this.$emit('prefix-action', action, item);
                }
            }
            catch (e) {
                // Dialog cancelled
            }
        }
    },
});
